import { AbstractModel } from './AbstractModel'
import { Voting } from './Voting'

export class VotingAnswer extends AbstractModel {
  public id: number|null = null;
  public name: string|null = null;
  public voting: Voting|null = null;
  public votes: number|null = null;
  public createdAt: string|null = null;
  public updatedAt: string|null = null;
}
